import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { AlertService, Dialog } from '../alert.service';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { Subject } from 'rxjs';
import { FunctionService } from '../function.service';

@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.css'],
    standalone: false
})
export class SideBarComponent implements OnInit {

    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

    @Output() SelectGalleryFoldersIndexEmit = new EventEmitter<string[]>();
    @Output() MainStatusEmit = new EventEmitter<string>();

    backGroundImage = "";
    backGroundImageChild = "";
    GalleryFolders: any;
    Version: string = '50';
    GalleryJustHidden: boolean = false;
    GalleryFolderIndex: number;
    SelectedFolder: [];
    YESPressed: Subject<Dialog>;
    showSubMenu: Boolean[] = [false, false, false];
    hoverLinks: Boolean = false;
    hoverScroll: Boolean = false;

  constructor(private APIService: APIService, public DataService: DataService, private AlertService: AlertService, private FunctionService: FunctionService) { 
    this.YESPressed = this.AlertService.YESPressed;
  }

    async ngOnInit() {
        this.GalleryFolders = await this.APIService.GetGalleryFolders();
        
        this.YESPressed.subscribe( data => {
            this.YESButtonPressedOnDialog(data);
        }) 
        if (sessionStorage.hasOwnProperty('MainStatus')) {
            this.DataService.MainStatus = sessionStorage.getItem('MainStatus' );
        }
        if (sessionStorage.hasOwnProperty('TornStatus')) {
            this.DataService.TornStatus = sessionStorage.getItem('TornStatus' );
        }
        this.DataService.LoadState()
    }

    delayedLeave(menu) {//this is for the hover events on Gallery & Links
        setTimeout(() => {
            if (this.hoverScroll == false) {
                this.showSubMenu[menu] = false
            }
        }, 100);
        this.hoverLinks = false;
    }

    ScrollDelayedLeave(menu) {//this is for the hover events on Gallery & Links
        setTimeout(() => {
            if (this.hoverLinks == false) {
                this.showSubMenu[menu] = false
            }
        }, 100);
        this.hoverScroll = false;
    }

    async YESButtonPressedOnDialog(DialogData) {
        if (DialogData.title == "Join Mailing List") {
            if (DialogData.InputResponses[0] != "") {
                //send email to Owen re mailing list
                var Result = await this.APIService.joinMailingList(DialogData.InputResponses[0]);
                if (Result == "Email Sent") {
                    this.AlertService.showSimpleAlert(DialogData.InputResponses[0] + " has been add to the Racketlon NZ mailing list");
                } else {
                    this.AlertService.showSimpleAlert(Result + " happened while trying to add you to the Racketlon NZ mailing list :(");
                }
            } else {
                this.AlertService.showSimpleAlert("You need to enter a valid email address");
            }
        }
    }

    getGalleryFolders(GF) {
        this.GalleryFolders = GF;
      }

    someMethod() {
        if (this.GalleryJustHidden == false) {
            this.trigger.openMenu();
        }
      }

      hideMenu() {
            this.trigger.closeMenu();
      }

      ShowTheImages(index) {
        this.GalleryFolderIndex = index
        this.DataService.changeMainStatus('Gallery');
        this.GalleryJustHidden = true;
        setTimeout(() => {
            this.GalleryJustHidden = false;
        }, 1000);
        this.SelectedFolder = this.GalleryFolders[index];
        this.SelectGalleryFoldersIndexEmit.emit(this.SelectedFolder);
      }

      calcRankings() {

      }

  goChart() {
    this.DataService.SelectedMatch = null;
    this.backGroundImage = "url(../images/background.png";
    this.backGroundImageChild = "url(../images/background.png";
    this.DataService.changeMainStatus('Chart');
    }

    goHome() {
        this.DataService.SelectedMatch = null;
        this.backGroundImageChild = "url(../images/background.png";
        this.DataService.changeMainStatus('Home');
    }

    goRules() {
        this.DataService.SelectedMatch = null;
        this.backGroundImage = "url(../images/background.png";
        this.backGroundImageChild = "url(../images/background.png";
        this.DataService.changeMainStatus('Rules');
    }

    goRankings() {
        this.DataService.SelectedMatch = null;
        this.backGroundImage = "url(../images/background.png";
        this.backGroundImageChild = "url(../images/background.png";
        this.DataService.changeMainStatus('Rankings');
    }

    goLogin() {
        this.DataService.SelectedMatch = null;
        this.backGroundImage = "url(../images/background.png";
        this.backGroundImageChild = "url(../images/background.png";
        this.DataService.changeMainStatus('Login');
        this.DataService.SaveState();
    }

    goTorns() {
        this.DataService.SelectedMatch = null;
        this.backGroundImage = "url(../images/background.png";
        this.backGroundImageChild = "url(../images/background.png";
        this.DataService.changeTornStatus('ChangeTorn');
        this.DataService.changeMainStatus('Torns');
        this.FunctionService.WhichTornsIsLoggedInUserIn();
    }

    goDatabase() {
        this.backGroundImage = "url(../images/background.png";
        this.backGroundImageChild = "url(../images/background.png";
        this.DataService.changeMainStatus('Database');
    }

    goHistory() {
        this.DataService.SelectedMatch = null;
        this.DataService.changeMainStatus('History');
    }

    goVideoFiles() {
        this.DataService.changeMainStatus('Videos');
    }

    goUserMaintenance() {
        this.DataService.changeMainStatus('UserMaintenance');
    }

    joinMailingList() {
        var InputList = [];
        InputList.push("Email");
        this.AlertService.showDialog("Join Mailing List", "YesNo", InputList, "Would you like to join the Racketlon NZ mailing list?", "Standard");
    }

}
